import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const PrivateRoute = ({ component: Component, authReducer, ...rest }) => (
    <Route {...rest} render = {props =>
        authReducer.isAuthenticated === true
            ? authReducer.user.toChangePass === false
                ? <Component {...props} />
                : <Redirect to="/reestablecimiento-contrasena" />
            : <Redirect to="/login" />
    }/>
);

PrivateRoute.propTypes = {
    authReducer: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    authReducer: state.authReducer
});

export default connect(mapStateToProps)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/components/common/PrivateRoute.js